 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		52: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"6b701b07c1f119c34b33e8deba9cbfd4f22a9805","2":"component---src-pages-404-mdx","3":"component---src-pages-code-example-mdx","4":"component---src-pages-docs-api-endpoint-action-register-mdx","5":"component---src-pages-docs-api-endpoint-channel-search-mdx","6":"component---src-pages-docs-api-endpoint-get-gif-by-id-mdx","7":"component---src-pages-docs-api-endpoint-get-gifs-by-id-mdx","8":"component---src-pages-docs-api-endpoint-mdx","9":"component---src-pages-docs-api-endpoint-random-id-mdx","10":"component---src-pages-docs-api-endpoint-random-mdx","11":"component---src-pages-docs-api-endpoint-search-mdx","12":"component---src-pages-docs-api-endpoint-translate-mdx","13":"component---src-pages-docs-api-endpoint-trending-mdx","14":"component---src-pages-docs-api-endpoint-upload-mdx","15":"component---src-pages-docs-api-mdx","16":"component---src-pages-docs-api-quick-start-guide-mdx","17":"component---src-pages-docs-api-response-codes-mdx","18":"component---src-pages-docs-api-schema-analytics-object-mdx","19":"component---src-pages-docs-api-schema-channel-object-mdx","20":"component---src-pages-docs-api-schema-gif-object-mdx","21":"component---src-pages-docs-api-schema-image-object-mdx","22":"component---src-pages-docs-api-schema-mdx","23":"component---src-pages-docs-api-schema-meta-object-mdx","24":"component---src-pages-docs-api-schema-pagination-object-mdx","25":"component---src-pages-docs-api-schema-random-id-object-mdx","26":"component---src-pages-docs-api-schema-user-object-mdx","27":"component---src-pages-docs-index-tsx","28":"component---src-pages-docs-optional-settings-language-support-mdx","29":"component---src-pages-docs-optional-settings-mdx","30":"component---src-pages-docs-optional-settings-rating-mdx","31":"component---src-pages-docs-optional-settings-rendition-guide-mdx","32":"component---src-pages-docs-resource-code-examples-mdx","33":"component---src-pages-docs-resource-mdx","34":"component---src-pages-docs-resource-support-mdx","35":"component---src-pages-docs-sdk-android-mdx","36":"component---src-pages-docs-sdk-content-types-mdx","37":"component---src-pages-docs-sdk-data-collection-mdx","38":"component---src-pages-docs-sdk-design-guidelines-mdx","39":"component---src-pages-docs-sdk-grid-mdx","40":"component---src-pages-docs-sdk-ios-mdx","41":"component---src-pages-docs-sdk-mdx","42":"component---src-pages-docs-sdk-overview-mdx","43":"component---src-pages-docs-sdk-verification-mdx","44":"component---src-pages-docs-style-guide-mdx","45":"component---src-pages-docs-trust-and-safety-mdx","46":"component---src-pages-docs-trust-and-safety-safe-search-terms-mdx","47":"component---src-pages-faq-mdx","48":"component---src-pages-index-mdx","49":"component---src-pages-landing-mdx","50":"component---src-pages-verification-index-tsx"}[chunkId]||chunkId) + "-" + {"0":"99237967efb43f321bf0","2":"24c870b4230c8111edc4","3":"a45c91775d808532a935","4":"0c5360eba4305ed93bf6","5":"2de158c61807730eefec","6":"02816e6199189a057a38","7":"a25ed457bb72e0b0028a","8":"ddbc93b30ced4013a3c8","9":"38a12cb368462927ca36","10":"c15f03bb7cfff2069120","11":"4f8b8729a4230335eb0c","12":"2b73524dc1e7cff2e702","13":"3ba3ae560d4aa6d8b547","14":"1416d54d2119435fc0cb","15":"1fbd47d9f0378cc3dedf","16":"6689334469af6a399f6f","17":"32c4138a645d2fc97292","18":"5550ea10ced97aa1b500","19":"e6b0a5d187ed8c8b619c","20":"4315c8c6536646e2cae4","21":"1051f5c1c402bef535af","22":"83d8da1be6059350bfc4","23":"98753b4a78281ab7ce39","24":"01405759405d4b883ef9","25":"0946eaac52716e56da43","26":"0caba91ff8cf00cf60b5","27":"4745033fd0d852750f09","28":"07d7c0f87f5c00a4c26d","29":"730f76233877e2f18ae0","30":"aa2c25a3d48502f80987","31":"9df7c65443556d88cdb0","32":"357890da29a8c6d89028","33":"464c1de9fe897af33f9b","34":"50d2f2205772a6fca566","35":"f708ac615c25cffe5205","36":"0266350f2247a1469ffe","37":"73cdbcc8cb1664a67098","38":"f42247590d7ce37f9a7f","39":"cab1b807a76468c06e79","40":"c4332b4a09b7da80074a","41":"cb1bcce1eec8ce87faa9","42":"21edf72abe1497394b0c","43":"b2336bad086a4243b94f","44":"92379ab4a5334ead60fc","45":"feec7644ba18b89854ae","46":"7a1b37934f2aaf1ad563","47":"0a32f66352242c016436","48":"0ec04d3008797d275883","49":"cd2e665b19784341e04c","50":"4d0b798ef24a5380fa32"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://developers.giphy.com/branch/master/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
